// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HEAg","rootMobile":"styles_rootMobile__1Iq91"};